import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@tq/ui-components/dist/components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';

type ReportDateProps = {
  complete: boolean;
};

export const StatusIndicator: React.FC<ReportDateProps> = ({ complete }) => {
  const { t } = useTranslation('report');

  return (
    <Badge
      display='flex'
      alignItems='center'
      justifyContent='center'
      fontSize='sm'
      mr={0}
      width='6.123rem'
      height='auto'
      bg={complete ? COLOURS.neutral[10] : COLOURS.yellow[500]}
      color={COLOURS.black[600]}
    >
      {complete ? t('complete', 'complete') : t('draft', 'draft')}
    </Badge>
  );
};
